import React from 'react';

function IframeComponent({ src, height, width }) {
    return <iframe src={src || 'https://www.example.com'} height={height || '300'} width={width || '100%'}></iframe>;
}

export default IframeComponent;
